import { createRouter, createWebHashHistory } from 'vue-router'
import WeatherMap from '../components/WeatherMap.vue'
import AlarmPane from '../components/AlarmPane.vue'
import RadarPane from '../components/RadarPane.vue'
import SeverePane from '../components/SeverePane.vue'
import RoadPane from '../components/RoadPane.vue'
import RoadCondPane from '../components/RoadCondPane.vue'

const routes = [
  {
    path: '/',
    name: 'WeatherMap',
    component: WeatherMap,
    children: [
      { path:  '', redirect: 'radar'},
      { path:  'alarm', name: 'alarm', component: AlarmPane },
      { path:  'severe', name: 'severe', component: SeverePane },
      { path:  'road', name: 'road', component: RoadPane },
      { path:  'radar', name: 'radar', component: RadarPane },
      { path:  'roadcond', name: 'roadcond', component: RoadCondPane },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
